import {Component} from 'react'
import PropTypes from 'prop-types'

import WizardActions from '../../../actions/WizardActions'
import PhoneEditForm from '../shared/PhoneEditForm'

import TfaWizardStepFrame from './TfaWizardStepFrame'


export default class PrimaryPhoneForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      mode: 'text',
      loading: false,
      isValid: false,
      nationalNumber: '',
      value: '',
      error: ''
    }

    this.clearErrors = this.clearErrors.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.setFormValue = this.setFormValue.bind(this)
    this.setMode = this.setMode.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        loading: false,
        error: nextProps.error
      })
    }
  }

  setFormValue(isValid, nationalNumber, value) {
    this.setState({isValid, nationalNumber, value})
  }

  setMode(mode) { this.setState({mode}) }

  handleSubmit(event) {
    if (event) event.preventDefault()
    if (this.state.isValid) {
      this.setState({loading: true})
      this.props.createPrimaryPhoneNumber({
        number: this.state.value,
        nationalNumber: this.state.nationalNumber,
        preferredMessageMode: this.state.mode
      })
    } else {
      this.setState({error: 'Please enter a valid number.'})
    }
  }

  clearErrors() {
    WizardActions.clearTfaErrors()
    this.setState({error: null})
  }

  render() {
    return (
      <TfaWizardStepFrame
        currentStep={2}
        onPrimaryAction={this.handleSubmit}
        onSecondaryAction={this.props.onBack}
        primaryActionLabel='Send code'
        primaryLoading={this.state.loading}
        secondaryActionLabel='Back'
        subtitle="We'll send a verification code to this number."
        title='Enter your phone number'>
        <form className='tfa-wizard-form' onSubmit={this.handleSubmit}>
          <div onFocus={this.clearErrors}>
            <PhoneEditForm
              deliveryLabel='Preferred delivery method'
              error={this.state.error}
              inputPlaceholder='(555) 555-5555'
              mode={this.state.mode}
              numberLabel='Phone number'
              radioName='primary-message-mode'
              setFormValue={this.setFormValue}
              setMode={this.setMode}
              textOptionDescription='Receive a code via text message'
              textOptionLabel='Text message (SMS)'
              variant='wizard'
              voiceOptionDescription='Receive a code via automated call'
              voiceOptionLabel='Phone call (Voice)'
            />
          </div>
        </form>
      </TfaWizardStepFrame>
    )
  }
}

PrimaryPhoneForm.propTypes = {
  closer: PropTypes.func,
  createPrimaryPhoneNumber: PropTypes.func.isRequired,
  error: PropTypes.string,
  onBack: PropTypes.func
}

PrimaryPhoneForm.defaultProps = {
  closer: null,
  error: '',
  onBack: null
}
